import React, { Component } from 'react';
import { Menu } from 'antd';
import { Modal } from 'view/common';
import {
  Share, AddAddress, NewProject, AddProviders, Why, AddressCard, EditAddresses,
} from 'view/screens';
import cx from 'classnames';
import { ProjectOptions, ProjectInfo, ProjectNavbar } from './components/index';
import './style.scss';

type Props = {};

type State = {};

class Project extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showAddProviderMenu: false,
      isAddressView: false,
      isTileView: true,
      showProjectsDropdown: false,
      filter: null,
      addressList: [],
      addressSearchValue: '',
      projectTitle: '',
      providerFilter: '',
      isPublicView: false,
      providerSearchValue: '',
      shareEnabled: false,
      addressAddIndividual: false,
      activeWhyIndex: null,
      activeAddress: null,
    };
  }

  componentDidMount() {
    this.dragOver = window.addEventListener('dragover', (e) => {
      e.preventDefault();
    }, false);
    this.drop = window.addEventListener('drop', (e) => {
      e.preventDefault();
    }, false);
    this.dropDownCloseHandler = window.addEventListener('click', () => {
      if (this.state.showProjectsDropdown) {
        this.setState({
          showProjectsDropdown: false,
        });
      }
      return null;
    });
  }

  componentWillUnmount() {
    window.removeEventListener('dragover', this.dragOver);
    window.removeEventListener('drop', this.drop);
    window.removeEventListener('click', this.dropDownCloseHandler);
  }

  toggleState = key => setTimeout(() => {
    this.setState(state => ({
      [key]: !state[key],
    }));
  }, 0);

  applyProviders = () => {
    this.setState({ showAddProviderMenu: false });
  };

  chooseFilter = e => e;

  openAddProvidersPopup = () => this.providersModal.open();

  handleShareModal = () => {
    this.shareModal.open();
  };

  handleAddressModal = () => {
    this.addressModal.open();
  };

  openShowDetail = (address) => {
    this.setState({ activeAddress: address });
    this.addressCardModal.open();
  };

  closeAddProvidersPopup = () => {
    this.providersModal.close();
    this.setState({ showAddProviderMenu: false });
  };

  openWhyPopup = () => this.whyModal.open();

  addressSubmit = () => {
    // submit addresses here
    this.addressModal.close();
  };

  handleNewProjectModal = () => {
    this.newProjectModal.open();
  };

  handleEditAddresses = () => {
    this.editAddresses.open();
  };

  newProjectSubmit = () => {
    // create a project here
    this.newProjectModal.close();
  };

  handleInput = (event) => {
    const { name, value } = event.target;
    this.setState(state => ({
      [name]: value,
      dropdownVisible: !!(name === 'addressSearchValue' && state.addressSearchValue.length < value.length),
    }));
  };

  switchTheme = () => {
    const { switchTheme, isDarkTheme } = this.props;
    switchTheme(!isDarkTheme);
  };

  addProviders = () => { };

  copyShareLink = () => {
    const copyText = document.getElementById('share-link').innerHTML;
    try {
      navigator.clipboard.writeText(copyText);
    } catch (e) {
      throw e;
    }

    if (this.state.shareEnabled) {
      this.props.dispatch({
        type: 'TOAST',
        payload: {
          text: 'Share link was copied to clipboard',
          color: '#216BB4',
        },
      });
    } else {
      this.props.dispatch({
        type: 'TOAST',
        payload: {
          text: 'Don\'t forget to enable sharing',
          color: '#F5A623',
        },
      });
    }
  };

  handleSelectOption = (activeWhyIndex) => {
    // handle predefined filters here
    // this.whyMod
    this.setState({ activeWhyIndex });
    return activeWhyIndex;
  };

  whyOptionSubmit = () => {
    this.whyModal.close();
    this.setState({ activeWhyIndex: null });
  };

  render() {
    const { isDarkTheme } = this.props;
    const {
      showAddProviderMenu, isAddressView, showProjectsDropdown, isTileView, filter, isPublicView,
      providerFilter, providerSearchValue, activeWhyIndex, activeAddress,
    } = this.state;

    const dropdownOptions = [
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
    ];

    const projectSettings = (
      <Menu>
        <Menu.Item key="0">
          <a href="/">Duplicate Project</a>
        </Menu.Item>
        <Menu.Item key="1">
          <a href="/">Delete project</a>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className={cx('project_container', {
        project_container_public: isPublicView,
      })}
      >
        {isPublicView
          ? (
            <div className="project_navbar">
              <h2 className="project_navbar_header" style={{ cursor: 'default' }}>Project 1</h2>
            </div>
          ) : (
            <ProjectNavbar
              selectedProject="Project 1"
              projectSettings={projectSettings}
              showProjectsDropdown={showProjectsDropdown}
              toggleState={this.toggleState}
              handleShareModal={this.handleShareModal}
              handleAddressModal={this.handleAddressModal}
              handleEditAddresses={this.handleEditAddresses}
              handleNewProjectModal={this.handleNewProjectModal}
              isDarkTheme={isDarkTheme}
              switchTheme={this.switchTheme}
            />
          )}
        <div className={cx('project_main_section', {
          project_main_section_public: isPublicView,
        })}
        >
          {!isPublicView && (
            <ProjectOptions
              showAddProviderMenu={showAddProviderMenu}
              applyProviders={this.applyProviders}
              toggleState={this.toggleState}
              openAddProvidersPopup={this.openAddProvidersPopup}
              isDarkTheme={isDarkTheme}
            />
          )}
          <ProjectInfo
            toggleState={this.toggleState}
            isAddressView={isAddressView}
            isTileView={isTileView}
            chooseFilter={this.chooseFilter}
            filter={filter}
            isPublicView={isPublicView}
            openWhyPopup={this.openWhyPopup}
            toggleShowDetail={this.openShowDetail}
            isDarkTheme={isDarkTheme}
          />
        </div>

        {/* modals */}

        <Modal ref={(r) => { this.shareModal = r; }}>
          <Share
            shareEnabled={this.state.shareEnabled}
            onChange={() => this.toggleState('shareEnabled')}
            onCopy={this.copyShareLink}
          />
        </Modal>
        <Modal ref={(r) => { this.providersModal = r; }}>
          <AddProviders
            title="Add Providers"
            providerSearchValue={providerSearchValue}
            dropdownVisible={false}
            handleInput={e => this.setState({ providerSearchValue: e.target.value })}
            submit={this.addProviders}
            providerFilter={providerFilter}
            chooseProviderFilter={(e, key) => this.setState({ providerFilter: key })}
            cancel={this.closeAddProvidersPopup}
            isDarkTheme={isDarkTheme}
          />
        </Modal>
        <Modal ref={(r) => { this.addressModal = r; }}>
          <AddAddress
            addressSearchValue={this.state.addressSearchValue}
            addressList={this.state.addressList}
            handleInput={this.handleInput}
            submit={this.addressSubmit}
            cancel={() => this.addressModal.close()}
            dropdownOptions={dropdownOptions}
            dropdownVisible={this.state.dropdownVisible}
            individual={this.state.addressAddIndividual}
            toggleIndividual={() => this.toggleState('addressAddIndividual')}
            isDarkTheme={isDarkTheme}
          />
        </Modal>
        <Modal ref={(r) => { this.newProjectModal = r; }}>
          <NewProject
            addressSearchValue={this.state.addressSearchValue}
            projectTitle={this.state.projectTitle}
            addressList={this.state.addressList}
            handleInput={this.handleInput}
            submit={this.newProjectSubmit}
            cancel={() => this.newProjectModal.close()}
            dropdownOptions={dropdownOptions}
            dropdownVisible={this.state.dropdownVisible}
            individual={this.state.addressAddIndividual}
            toggleIndividual={() => this.toggleState('addressAddIndividual')}
            isDarkTheme={isDarkTheme}
          />
        </Modal>
        <Modal ref={(r) => { this.addressCardModal = r; }} addressDetails>
          <AddressCard activeAddress={activeAddress} />
        </Modal>
        <Modal ref={(r) => { this.whyModal = r; }}>
          <Why
            handleSelectOption={option => this.handleSelectOption(option)}
            submit={this.whyOptionSubmit}
            cancel={() => this.whyModal.close()}
            activeWhyIndex={activeWhyIndex}
          />
        </Modal>
        <Modal ref={(r) => { this.editAddresses = r; }}>
          <EditAddresses
            handleSelectOption={option => this.handleSelectOption(option)}
          />
        </Modal>
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/view/screens/Project/Project.jsx